import { conciliationStatus } from "../components/ConciliationStatusChip";

export const getLoteStatusOptions = (records) => {
  const options = new Map();
  records.forEach((row) => {
    const raw = String(row.status ?? "").trim();
    const label = conciliationStatus(raw).label;
    if (!options.has(label)) options.set(label, { value: raw || "__no_informado", label });
  });
  return [...options.values()].sort((a, b) => a.label.localeCompare(b.label, "es"));
};
export const matchesLoteStatus = (status, filter) =>
  !filter ||
  filter === "todos" ||
  conciliationStatus(status).label ===
    conciliationStatus(filter === "__no_informado" ? null : filter).label;
